import React, { Component } from 'react';
const jobContext=React.createContext(
      {
        data: '',
        AddSkill: (s) => {}
      }
);
class ContextComponent extends Component{
    constructor(props)
    {
        super(props)
        this.state={
            data:{JobId:654892,
            JobTitle:"Full Stack .net Developer",
            JobDescription:"Required Full Stack .net developer For location lousville Ky Nice to Have Health Insurance Domain Knowledge",
            JobSkill:"C#,ADO.Net,WEb Api,JAva Script,Jquery,Entity Frame Work",
            JobRate:100000
            },
           ButtonDisplay:"NextJob",
           AddSkill:this.AddSkills
        }
    }
    AddSkills=(skill)=>{
       
        this.setState({
            data:{
                ...this.state.data,               
                JobSkill:this.state.data.JobSkill + "," +  skill
            }
        })
    }
    NextJob= () =>{
         this.setState({
         data:(this.state.ButtonDisplay === "NextJob") ? 
                {
                JobId:654893,
                JobTitle:"Full Stack .net Developer",
                JobDescription:"Required Full Stack .net developer For location lousville Ky Nice to Have Health Insurance Domain Knowledge",
                JobSkill:"React,Js",
                JobRate:120000
                } :
                {
                JobId:654892,
                JobTitle:"Full Stack .net Developer",
                JobDescription:"Required Full Stack .net developer For location lousville Ky Nice to Have Health Insurance Domain Knowledge",
                JobSkill:"C#,ADO.Net,WEb Api,JAva Script,Jquery,Entity Frame Work",
                JobRate:100000
                },
                ButtonDisplay:(this.state.ButtonDisplay === "NextJob") ? "PreviousJob":"NextJob"
                })
    }
    render (){
        return (
            <div>
             <h1>Job Requirement </h1>
             <p><label>Job Id -- <b> {this.state.data.JobId} </b></label></p>
             <p><label>Job Title -- <b> {this.state.data.JobTitle} </b></label></p>
             <jobContext.Provider value={this.state}>
               <JObComponent />
             </jobContext.Provider>           
             <p><label><button onClick={this.NextJob}>{this.state.ButtonDisplay}</button></label></p>
           </div>
        )
   }
}
class JObComponent extends Component {
    static contextType = jobContext;     
    render(){
        
        return(
            <div>
             <h1>Job Requiredment</h1>
              {this.context.data.JobDescription}
             <JObRequiredSkill></JObRequiredSkill>
            </div>
        )
    }
}
class JObRequiredSkill extends Component {
    constructor(props){
        super(props)
        this.state={
            newSkill:''
        }
    }
  AddSkill=()=>{
      let newskill=this.refs.Skill.value    
      this.context.AddSkill(newskill)
  }
  static contextType = jobContext;    
      render(){
          return(
            <div>
                <h1>Job Skill Requirement</h1>
                <label>Employee Salary : <b><input type="Salary" name="Salary" value = {this.setState.newSkill}  ref="Skill"/></b></label><button onClick={this.AddSkill}>AddSkill</button><br></br>
                {this.context.data.JobSkill}
            </div>
        )
    }
}
export default ContextComponent